class VariantQuickShopSelects extends HTMLElement {
    constructor() {
        super();
        this.variantSelect = this;
        this.item = $(this.variantSelect).closest('.quickshop');

        if (this.variantSelect.classList.contains('has-default')) {
            this.updateOptions();
            this.updateMasterId();
            this.renderProductInfo();
        }

        if (!this.currentVariant) {
            this.item[0].dataset.inStock = 'false'
        } else {
            if (this.item[0]) {
                this.item[0].dataset.inStock = this.currentVariant.available ? 'true' : 'false'
            }
        }

        var inventory = this.currentVariant?.inventory_management;

        if (inventory != null) {
            var productId = this.item.data('cart-edit-id'),
                arrayInVarName = 'edit_cart_inven_array_' + productId,
                inven_array = window[arrayInVarName];

            if (inven_array != undefined) {
                var inven_num = inven_array[this.currentVariant.id],
                    inventoryQuantity = parseInt(inven_num);

                this.item.find('input[name="quantity"]').attr('data-inventory-quantity', inventoryQuantity);
            }
        }

        this.onVariantInit();
        this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantInit() {
        this.updateVariantStatuses();
        this.syncProductForm();
    }

    onVariantChange(event) {
        this.updateVariantStatuses();
        this.syncProductForm();
        this.notifySiblingVariantComponents();

        if (!this.currentVariant) {
            this.updateAttribute(true);
        } else {
            this.updateMedia();
            this.updatePrice();
            this.renderProductInfo();
            this.updateAttribute(false, !this.currentVariant.available);
            this.updateAddToCartButtonState();
        }

        this.updateAddToCartButton();
        
        if($('.dropdown-item[data-currency]').length){
            if ((window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency) {
                Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
            }
        }
    }

    updateOptions() {
        this.options = [];

        const container = this.closest('.halo-productOptions');

        for (let i = 0; i < 3; i++) {
            const wrapper = container?.querySelector(`[data-option-index="${i}"]`);

            if (!wrapper) continue;

            const radio = wrapper.querySelector('input[type="radio"]:checked');
            const select = wrapper.querySelector('select');

            this.options[i] =
                radio?.value ||
                select?.value ||
                null;
        }
    }

    decodeOptions() {
        this.options = this.options.map(option => this.decodeOption(option));
    }

    decodeOption(option) {
        if (option) {
            return option.split('Special_Double_Quote').join('"').split('Special_Slash').join('/');
        }

        return null;
    }

    updateMasterId() {
        this.currentVariant = this.resolveCurrentVariant();
    }

    getVariantContainer() {
        return this.closest('.halo-productOptions');
    }

    resolveCurrentVariant() {
        this.updateOptions();
        this.decodeOptions();

        const variants = this.getVariantData();

        return variants.find((variant) =>
            variant.options.every((option, index) =>
                this.optionsMatch(this.options[index], option)
            )
        ) || variants.find((variant) =>
            [0, 1, 2].every((index) =>
                this.optionsMatch(this.options[index], variant[`option${index + 1}`])
            )
        );
    }

    syncProductForm() {
        this.currentVariant = this.resolveCurrentVariant();

        if (!this.currentVariant) {
            return;
        }

        const quickshop = this.closest('.quickshop');
        const productId = this.dataset.product;

        quickshop?.querySelectorAll(`#product-quick-view-form-${productId} input[name="id"]`).forEach((input) => {
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });

        if (quickshop) {
            quickshop.dataset.inStock = this.currentVariant.available ? 'true' : 'false';
        }

        const qtyInput = quickshop?.querySelector('input[name="quantity"]');
        const inventoryArr = window[`quick_view_inven_array_${productId}`];

        if (qtyInput) {
            qtyInput.setAttribute('data-price', this.currentVariant.price);

            if (inventoryArr?.[this.currentVariant.id] !== undefined) {
                qtyInput.setAttribute('data-inventory-quantity', inventoryArr[this.currentVariant.id]);
            }
        }

        this.updateAddToCartButtonState();
    }

    updateAddToCartButtonState() {
        if (!this.currentVariant) {
            return;
        }

        const button = this.closest('.quickshop')?.querySelector('[data-btn-addToCart]');

        if (!button) {
            return;
        }

        const productId = this.dataset.product;
        const inventoryArr = window[`quick_view_inven_array_${productId}`];
        const inventoryQuantity = parseInt(inventoryArr?.[this.currentVariant.id], 10);
        const hasInventoryTracking = this.currentVariant.inventory_management != null;

        if (!this.currentVariant.available) {
            button.disabled = true;
            button.textContent = window.variantStrings.soldOut;
            return;
        }

        button.disabled = false;

        if (hasInventoryTracking && inventoryQuantity <= 0) {
            button.textContent = window.variantStrings.preOrder;
        } else {
            button.textContent = window.variantStrings.addToCart;
        }
    }

    updateMedia() {
        if (!this.currentVariant || !this.currentVariant?.featured_media) return;
        setTimeout(() => {
            const newMedia = document.querySelector(
                `[data-media-id="${this.dataset.product}-${this.currentVariant.featured_media.id}"]`
            );
            if (!newMedia) return;
            window.setTimeout(() => {
                $(newMedia).trigger('click');
            }, 200);
        }, 100);
    }

    updateVariantInput() {
        this.syncProductForm();
    }

    updatePrice() {
        const itemPrice = this.item.find('.productView-price');

        if (!itemPrice) return;

        var price = this.currentVariant?.price,
            compare_at_price = this.currentVariant?.compare_at_price;

        itemPrice.find('.price').html(Shopify.formatMoney(price, window.money_format)).show();

        if (compare_at_price > price) {
            itemPrice.find('.compare-price').html(Shopify.formatMoney(compare_at_price, window.money_format)).show();
            itemPrice.find('.price').addClass('new-price');
        } else {
            itemPrice.find('.compare-price').hide();
            itemPrice.find('.price').removeClass('new-price');
        }
    }

    renderProductInfo() {
        var inventory = this.currentVariant?.inventory_management;

        if (inventory != null) {
            var productId = this.item.data('cart-edit-id'),
                arrayInVarName = 'edit_cart_inven_array_' + productId,
                inven_array = window[arrayInVarName];

            if (inven_array != undefined) {
                var inven_num = inven_array[this.currentVariant.id],
                    inventoryQuantity = parseInt(inven_num);

                this.item.find('input[name="quantity"]').attr('data-inventory-quantity', inventoryQuantity);

                if (this.item.find('.product-edit-hotStock').length > 0) {
                    var hotStock = this.item.find('.product-edit-hotStock'),
                        maxStock = hotStock.data('edit-cart-hot-stock');

                    if (inventoryQuantity > 0 && inventoryQuantity <= maxStock) {
                        var textStock = window.inventory_text.hotStock.replace('[inventory]', inventoryQuantity);
                        hotStock.text(textStock).show();
                    } else {
                        hotStock.hide();
                    }
                }
            }
        }
    }

    updateVariantStatuses() {
        this.updateOptions();
        this.decodeOptions();

        const inputWrappers = [...this.querySelectorAll('.product-form__input')];

        inputWrappers.forEach((wrapper) => {
            const optionIndex = parseInt(wrapper.dataset.optionIndex || 0);
            const optionPosition = optionIndex + 1;
            const header = wrapper.querySelector('[data-header-option]');

            if (header && this.options[optionIndex]) {
                header.innerText = this.options[optionIndex];
            }

            const optionInputs = [
                ...wrapper.querySelectorAll('input[type="radio"], option')
            ];

            const matchingVariants = this.getVariantData().filter((variant) => {
                for (let i = 0; i < optionIndex; i++) {
                    if (!this.options[i]) {
                        return false;
                    }

                    const variantOption = variant.options?.[i] ?? variant[`option${i + 1}`];

                    if (!this.optionsMatch(this.options[i], variantOption)) {
                        return false;
                    }
                }

                return true;
            });

            const optionInputsValue = [
                ...new Set(
                    matchingVariants.map(
                        variant => variant[`option${optionPosition}`]
                    )
                )
            ];

            const availableOptionInputsValue = [
                ...new Set(
                    matchingVariants
                        .filter(variant => variant.available)
                        .map(
                            variant => variant[`option${optionPosition}`]
                        )
                )
            ];

            this.setInputAvailability(
                optionInputs,
                optionInputsValue,
                availableOptionInputsValue,
                optionIndex
            );
        });
    }

    optionsMatch(selected, variantOption) {
        if (selected == null || selected === '') {
            return variantOption == null || variantOption === '';
        }

        if (variantOption == null) {
            return false;
        }

        return selected.trim().toLowerCase() === variantOption.trim().toLowerCase();
    }

    findVariantForSelections(selections, requireAllSelections = true) {
        return this.getVariantData().find((variant) =>
            variant.options.every((option, index) => {
                const selected = selections[index];

                if (selected == null || selected === '') {
                    return !requireAllSelections;
                }

                return this.optionsMatch(selected, option);
            })
        );
    }

    isOptionValueAvailable(optionIndex, value) {
        for (let i = 0; i < optionIndex; i++) {
            if (!this.options[i]) {
                return false;
            }
        }

        const decodedValue = this.decodeOption(value);

        return this.getVariantData().some((variant) => {
            const variantOption = variant.options?.[optionIndex] ?? variant[`option${optionIndex + 1}`];

            if (!this.optionsMatch(variantOption, decodedValue)) {
                return false;
            }

            for (let i = 0; i < optionIndex; i++) {
                const selectedOption = variant.options?.[i] ?? variant[`option${i + 1}`];

                if (!this.optionsMatch(this.options[i], selectedOption)) {
                    return false;
                }
            }

            return variant.available;
        });
    }

    optionValueExists(optionIndex, value) {
        const decodedValue = this.decodeOption(value);

        return this.getVariantData().some((variant) => {
            const variantOption = variant.options?.[optionIndex] ?? variant[`option${optionIndex + 1}`];

            if (!this.optionsMatch(variantOption, decodedValue)) {
                return false;
            }

            for (let i = 0; i < optionIndex; i++) {
                if (!this.options[i]) {
                    return false;
                }

                const selectedOption = variant.options?.[i] ?? variant[`option${i + 1}`];

                if (!this.optionsMatch(this.options[i], selectedOption)) {
                    return false;
                }
            }

            return true;
        });
    }

    refreshVariantStatuses() {
        this.updateVariantStatuses();
        this.syncProductForm();
    }

    notifySiblingVariantComponents() {
        const container = this.closest('.halo-productOptions');
        if (!container) return;

        container.querySelectorAll('variant-quick-shop-selects, variant-quick-shop-radios').forEach((element) => {
            if (element === this) return;

            element.refreshVariantStatuses();
        });
    }

    updateImageSwatch(selectedOptionOneVariants) {
        const inputWrappers = this.querySelectorAll('.product-form__input');
        if (inputWrappers) {
            inputWrappers.forEach((element, inputIndex) => {
                const imageSpan = element.querySelectorAll("label>span.pattern");
                const imageLabel = element.querySelectorAll("label");
                const imageSpanImage = element.querySelectorAll("label>span.expand>img");
                const inputList = element.querySelectorAll("input");

                inputList.forEach((item, index) => {
                    const image = selectedOptionOneVariants.filter(tmp => {
                        if (inputIndex == 0) return tmp.option1 == item.value;
                        if (inputIndex == 1) return tmp.option2 == item.value;
                        if (inputIndex == 2) return tmp.option3 == item.value;
                    });

                    if (image.length > 0) {
                        imageLabel[index].style.display = "inline-block";
                        if (imageSpan[index] != undefined && image[0].featured_image != null) imageSpan[index].style.backgroundImage = `url("${image[0].featured_image.src}")`;
                        if (imageSpanImage[index] != undefined && image[0].featured_image != null) imageSpanImage[index].srcset = image[0].featured_image.src;
                    }
                })
            });
        }
    }

    updateAttribute(unavailable = true, disable = true) {
        var alertBox = this.item.find('.alertBox'),
            quantityInput = this.item.find('input[name="quantity"]'),
            notifyMe = this.item.find('.product-edit-notifyMe'),
            hotStock = this.item.find('.productView-hotStock');

        if (unavailable) {
            this.item.removeClass('isChecked');
            quantityInput.attr('disabled', true);
            alertBox.find('.alertBox-message').text(window.variantStrings.unavailable_message);
            alertBox.show();
            notifyMe.slideUp('slow');

            if (hotStock.length > 0) {
                hotStock.hide();
            }
        } else {
            if (disable) {
                this.item.removeClass('isChecked');
                quantityInput.attr('disabled', true);
                alertBox.find('.alertBox-message').text(window.variantStrings.soldOut_message);
                alertBox.show();

                this.item.find('.quantity__message').empty().hide();

                if (notifyMe.length > 0) {
                    notifyMe.find('.halo-notify-product-variant').val(this.currentVariant.title);
                    notifyMe.find('.notifyMe-text').empty();
                    notifyMe.slideDown('slow');
                }
            } else {
                this.item.addClass('isChecked')
                quantityInput.attr('disabled', false);
                alertBox.find('.alertBox-message').text('');
                alertBox.hide();

                if (notifyMe.length > 0) {
                    notifyMe.slideUp('slow');
                }
            }
        }

        // if (this.item[0]) {
        //     this.item[0].dataset.inStock = this.currentVariant.available ? 'true' : 'false';
        // }
    }

    getVariantData() {
        const container = this.getVariantContainer();

        if (container && !container.variantDataCache) {
            const jsonElement = container.querySelector('[type="application/json"]');

            if (jsonElement) {
                container.variantDataCache = JSON.parse(jsonElement.textContent);
            }
        }

        if (container?.variantDataCache) {
            this.variantData = container.variantDataCache;
        } else if (!this.variantData) {
            const jsonElement = this.querySelector('[type="application/json"]');

            if (jsonElement) {
                this.variantData = JSON.parse(jsonElement.textContent);
            } else {
                this.variantData = [];
            }
        }

        return this.variantData;
    }

    updateAddToCartButton() {
        const editCartWrapper = this.variantSelect.closest('[data-template-cart-edit]');
        if (!editCartWrapper) return
        const productItems = [...editCartWrapper.querySelectorAll('.product-edit-item')];
        const updateEditCartButton = this.variantSelect.closest('[data-edit-cart-popup]').querySelector('[data-update-cart-edit]');
        const allValid = productItems.every(productItem => productItem.dataset.inStock == 'true');

        if (allValid) {
            updateEditCartButton.disabled = false
        } else {
            updateEditCartButton.disabled = true
        }
    }

    setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue, optionIndex) {
        optionInputs.forEach(input => {
            const value = input.getAttribute('value');
            const exists = this.optionValueExists(optionIndex, value);
            const isAvailable = this.isOptionValueAvailable(optionIndex, value);

            if (isAvailable) {
                input.classList.remove('soldout');
                input.innerText = value;
            } else {
                input.classList.add('soldout');
                input.innerText = exists
                    ? `${value} (Sold out)`
                    : window.variantStrings.unavailable_with_option.replace('[value]', value);
            }
        });
    }
}

customElements.define('variant-quick-shop-selects', VariantQuickShopSelects);

class VariantQuickShopCartRadios extends VariantQuickShopSelects {
    constructor() {
        super();
    }

   setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue, optionIndex) {
    optionInputs.forEach(input => {
        const inputValue = input.getAttribute('value');
        const exists = this.optionValueExists(optionIndex, inputValue);
        const isAvailable = this.isOptionValueAvailable(optionIndex, inputValue);

        if (isAvailable) {
            input.nextSibling?.classList.remove('soldout', 'unavailable');
            input.nextSibling?.classList.add('available');
        } else {
            input.nextSibling?.classList.remove('available', 'unavailable');
            input.nextSibling?.classList.add('soldout');

            if (window.variantStrings?.hide_variants_unavailable && !exists) {
                input.nextSibling?.classList.add('unavailable');

                if (input.checked) {
                    const inputsValue = availableOptionInputsValue.length > 0
                        ? availableOptionInputsValue
                        : optionInputsValue;

                    const newInput = input.closest('.product-form__input')?.querySelector(`input[value="${inputsValue[0]}"]`);
                    if (newInput) {
                        newInput.checked = true;
                        newInput.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
            }
        }
    });
   }
}

customElements.define('variant-quick-shop-radios', VariantQuickShopCartRadios);

class QuantityQuickShopInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.input.addEventListener('change', this.onInputChange.bind(this));
    }

    onInputChange(event) {
        event.preventDefault();
        var inputValue = this.input.value;
        const addButton = document.getElementById(`product-quick-view-form-${this.input.dataset.product}`)?.querySelector('[name="add"]');
        
        if(inputValue < 1) {
            inputValue = 1;

            this.input.value =  inputValue;
        }
            
        if(window.quick_view_subtotal.show) {
            var text,
                price = this.input.dataset.price,
                subTotal = 0;

            subTotal = inputValue * price;
            subTotal = Shopify.formatMoney(subTotal, window.money_format);
            subTotal = extractContent(subTotal);

            text = window.quick_view_subtotal.text.replace('[value]', subTotal);

            if (!document.body.classList.contains('quickshop-popup-show')) {
                addButton.textContent = text;
            }
        }
    }
}

customElements.define('quantity-quick-shop-input', QuantityQuickShopInput);